import React, { useEffect, useRef, useState } from "react";

/*
  Scroll-triggered version of the hero entrance animations.
  Wrap any block with <Reveal> and it fades/slides in the same way the
  hero content does, but the first time it scrolls into view instead of
  on page load.

  animation: "up" (default, fade + rise) | "fade" (opacity only) | "right" (slide in from right)
  delay: ms, staggers items inside a grid/list (e.g. delay={i * 80})
*/
const ANIMATION_CLASS = {
  up: "hero-fade-up",
  fade: "hero-fade-in",
  right: "hero-slide-right",
};

const Reveal = ({
  children,
  animation = "up",
  delay = 0,
  className = "",
  as: Tag = "div",
  style,
  ...rest
}) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold: 0, rootMargin: "0px 0px 4% 0px" }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={`${visible ? ANIMATION_CLASS[animation] : "opacity-0"} ${className}`}
      style={{ ...style, ...(visible && delay ? { animationDelay: `${delay}ms` } : null) }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
